import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function Newsletter() {
  const { t } = useTranslation();
  const [imageRef, imageVisible] = useScrollAnimation();
  const [contentRef, contentVisible] = useScrollAnimation();

  return (
    <div className="newsletter-wrapper">
      <div className="newsletter container">
        <img
          ref={imageRef}
          className={`newsletter-img ${imageVisible ? "animate-in" : ""}`}
          src="/assets/images/projectSolutions.jpg"
          alt="Newborn"
        />
        <div
          ref={contentRef}
          className={`newsletter-content ${contentVisible ? "animate-in" : ""}`}
        >
          <h2 className="fs-800 clr-white">{t("newsletter.title")}</h2>
          <p className="fs-400 newsletter-description">
            {t("newsletter.description")}
          </p>
          <div className="flex">
            <div className="newsletter-card">
              <img src="/assets/icons/quality.svg" alt="Quality Icon" />
              <h3 className="clr-white fs-500">
                {t("newsletter.qualityAssurance")}
              </h3>
              <p className="fs-400">{t("newsletter.qualityAssuranceDesc")}</p>
            </div>
            <div className="newsletter-card">
              <img src="/assets/icons/expert.svg" alt="Expert Icon" />
              <h3 className="clr-white fs-500">
                {t("newsletter.expertCraftsmanship")}
              </h3>
              <p className="fs-400">
                {t("newsletter.expertCraftsmanshipDesc")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Newsletter;
